import { Branch } from "../base/branch";
import { Realm } from "./realm";
import { Syndicate } from "./syndicate";

export class Import extends Branch {
    static _type: string = 'Import';

    constructor(alias: string) {
        super();
        this.name = alias;
    }

    loadChildren(realm: any, syndicate: any): void {
        const realmNode = new Realm(realm);
        this.branches.push(realmNode);
        realmNode.load(realm);

        const syndicateNode = new Syndicate(syndicate);
        this.branches.push(syndicateNode);
        syndicateNode.load(syndicate);
    }

    override fit(_: Branch): boolean {
        return false;
    }
}
